import { inject, Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { components, operations } from 'src/app/core/services/api/generated/ix-api.types';
import { IxRestApi } from 'src/app/core/services/api/ix-rest-api';

export type DistributionDto = components['schemas']['DistributionDto'];
export type DeliverableDistributionDto = components['schemas']['DeliverableDistributionDto'];
export type DeliverableDistributionRowDto = components['schemas']['DeliverableDistributionRowDto'];
export type DistributionValue = DistributionDto['availableValues'];
export type SidrlDto = components['schemas']['SidrlDto'];
export type DistributionDtoCodes = NonNullable<DistributionDto['availableValues']>[number];

@Injectable()
export class DistributionApiService {
  readonly #ixRestApi = inject(IxRestApi);
  getDistribution(path: operations['getDistribution']['parameters']['path']) {
    return this.#ixRestApi.get(
      { pathname: '/api/projects/{projectId}/distribution', options: { path } },
      undefined,
    );
  }

  updateDistribution(
    path: operations['updateDistribution']['parameters']['path'],
    requestBody: operations['updateDistribution']['requestBody']['content']['application/json'],
  ) {
    return this.#ixRestApi.put(
      { pathname: '/api/projects/{projectId}/distribution', options: { path } },
      requestBody,
    );
  }

  updateDistributions(projectId: number, updateSidrlRequests: SidrlDto[]) {
    return forkJoin(updateSidrlRequests.map(req => this.updateDistribution({ projectId }, req)));
  }

  getDeliverableDistribution(path: operations['getDeliverableDistribution']['parameters']['path']) {
    return this.#ixRestApi.get(
      { pathname: '/api/projects/{projectId}/deliverable-distribution', options: { path } },
      undefined,
    );
  }

  updateDeliverableDistribution(
    path: operations['updateDeliverableDistribution']['parameters']['path'],
    requestBody: operations['updateDeliverableDistribution']['requestBody']['content']['application/json'],
  ) {
    return this.#ixRestApi.put(
      { pathname: '/api/projects/{projectId}/deliverable-distribution', options: { path } },
      requestBody,
    );
  }

  updateDeliverableDistributions(projectId: number, updates: DeliverableDistributionRowDto[]) {
    return forkJoin(updates.map(row => this.updateDeliverableDistribution({ projectId }, row)));
  }
}
